import { CheckCircle2, AlertTriangle, HelpCircle, ShieldAlert, XCircle } from "lucide-react";

// Polaris-style semantic tones (soft tint + border + strong text).
export const TONE = {
  success: "bg-[#E4F8F0] text-[#004D38] border-[#95E3C4]",
  warning: "bg-[#FFF8E6] text-[#613A00] border-[#FFD6A5]",
  critical: "bg-[#FDE8E8] text-[#7A1408] border-[#F8B4B4]",
  highlight: "bg-[#F0F7FF] text-[#0369A1] border-[#BAE6FD]",
  neutral: "bg-[#F1F2F4] text-[#45494D] border-[#E1E3E5]",
};

export function Pill({ tone = "neutral", children, className = "", ...rest }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium leading-4 ${TONE[tone]} ${className}`} {...rest}>
      {children}
    </span>
  );
}

export function ConfidenceBadge({ level }) {
  const map = {
    high: { tone: "success", label: "High confidence", Icon: CheckCircle2 },
    medium: { tone: "warning", label: "Medium confidence", Icon: AlertTriangle },
    low: { tone: "critical", label: "Low confidence", Icon: XCircle },
  };
  const c = map[level] || map.low;
  const Icon = c.Icon;
  return (
    <Pill tone={c.tone} data-testid="confidence-badge">
      <Icon className="h-3 w-3" /> {c.label}
    </Pill>
  );
}

export function InsufficientBadge() {
  return (
    <Pill tone="critical" data-testid="insufficient-badge">
      <HelpCircle className="h-3 w-3" /> Insufficient evidence
    </Pill>
  );
}

export function ConflictBanner({ description }) {
  return (
    <div className="flex gap-2.5 items-start border border-[#FFD6A5] bg-[#FFF8E6] p-3 rounded-lg" data-testid="conflict-banner">
      <ShieldAlert className="h-4 w-4 text-[#B25900] mt-0.5 shrink-0" />
      <div>
        <div className="font-semibold text-sm text-[#613A00]">Conflict detected</div>
        <div className="text-sm mt-0.5 text-[#4A2C00]">{description || "Sources disagree. Review the cited passages before relying on this answer."}</div>
      </div>
    </div>
  );
}

export function CitationBadge({ label, active, onClick }) {
  return (
    <button onClick={onClick} data-testid="citation-badge"
      className={`font-mono-cite text-[11px] px-1.5 py-0.5 rounded-md border transition-colors ${
        active ? "bg-primary text-primary-foreground border-primary" : "bg-secondary text-secondary-foreground border-border hover:border-primary"
      }`}>
      {label}
    </button>
  );
}
